import { render } from "./SalesforceLeadForm.vue?vue&type=template&id=76f68f41&scoped=true&ts=true"
import script from "./SalesforceLeadForm.vue?vue&type=script&lang=ts"
export * from "./SalesforceLeadForm.vue?vue&type=script&lang=ts"

import "./SalesforceLeadForm.vue?vue&type=style&index=0&id=76f68f41&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f68f41"]])

export default __exports__